var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"events"},[(_vm.project != null)?_vm._l((_vm.project.events),function(event,index){return _c('div',{key:event.id,staticClass:"event"},[_c('Event',{attrs:{"project":_vm.project,"events":_vm.project.events,"event":event,"index":index}})],1)}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }